import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "./education.css";

const courses = [
  "Application Database", "Object Oriented Programming & Design",
  "Advanced Data Structures & Algorithms", "Discrete Structures",
  "Computer Networking", "CyberSecurity",
];

const classProjects = [
  {
    course: "Cyber Security",
    desc: "Developed a secure messaging application in a Linux VM using Python and Vim, implementing end-to-end encryption via ECDH key exchange and a basic blockchain mechanism for message integrity.",
  },
  {
    course: "Computer Networks",
    desc: "Architected a three-tier hierarchical infrastructure in Cisco Packet Tracer with VLSM, VLANs, 802.1Q trunking, Inter-VLAN routing with ACL policies, multi-area OSPF, DHCP, DNS, and PAT/NAT.",
  },
];

function Education() {
  const ref = useScrollReveal();

  return (
    <section ref={ref} id="education" className="education reveal">
      <div className="section-inner">
        <div className="section-header reveal-child" style={{ '--i': 0 }}>
          <span className="section-number font-mono">04</span>
          <h2 className="section-title">Education</h2>
        </div>

        <div className="edu-card reveal-child" style={{ '--i': 1 }}>
          <div className="edu-top">
            <div>
              <h3 className="edu-degree">B.S. Computer Science, Cyber Security</h3>
              <span className="edu-school font-mono">University of Central Oklahoma — Edmond, OK</span>
            </div>
            <span className="edu-period font-mono">2023 – 2027 (expected)</span>
          </div>

          <div className="edu-section-label font-mono">Relevant Coursework</div>
          <div className="edu-tags">
            {courses.map((c, i) => (
              <span className="tech-tag font-mono" key={i}>{c}</span>
            ))}
          </div>

          <div className="edu-section-label font-mono">Class Projects</div>
          <div className="edu-projects">
            {classProjects.map((p, i) => (
              <div className="edu-project" key={i}>
                <span className="edu-project-course font-mono">{p.course}</span>
                <p className="edu-project-desc">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Education;
